export const TERMINAL_STATUSES = ['pending_review', 'ready', 'failed'];
export const BUSY_STATUSES = ['processing', 'analyzing'];

export const statusColor = (status) => {
  switch (status) {
    case 'ready':
      return 'success';
    case 'pending_review':
      return 'warning';
    case 'processing':
      return 'neutral';
    case 'analyzing':
      return 'primary';
    case 'failed':
      return 'danger';
    default:
      return 'neutral';
  }
};

